import React, { Component } from "react";
import { Grid } from "react-bootstrap";
// import {basePathApi} from 'helper/basePathApi';
import {basePathClient} from 'helper/basePathClient';

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Grid fluid>
          
          <p className="copyright pull-right">
            &copy; {new Date().getFullYear()}{" "}
            <a href={basePathClient+'Admin'}>Wedding TripKit</a>
          </p>
        </Grid>
      </footer>
    );
  }
}

export default Footer;
